/// <reference types="jquery" />
/// <reference types="q" />
import Q = require("q");

import Dashboard_Shared_Contracts = require("Dashboards/Scripts/Contracts");
import TFS_Dashboards_Common = require("Dashboards/Scripts/Common");
import TFS_Dashboards_Resources = require("Dashboards/Scripts/Resources/TFS.Resources.Dashboards");
import TFS_Dashboards_Telemetry = require("Dashboards/Scripts/Telemetry");

import Dashboards_Services = require("TFS/Dashboards/Services");
import TFS_Dashboards_Contracts = require("TFS/Dashboards/Contracts");
import TFS_Dashboards_WidgetContracts = require("TFS/Dashboards/WidgetContracts");
import * as UserPermissionsHelper from "Dashboards/Scripts/Common.UserPermissionsHelper";

import Contribution_Services = require("VSS/Contributions/Services");
import Contributions_Controls = require("VSS/Contributions/Controls");
import Controls = require("VSS/Controls");

import Diag = require("VSS/Diag");
import Utils_String = require("VSS/Utils/String");
import VSS = require("VSS/VSS");
import * as Locations from "VSS/Locations";

import TFS_Dashboards_ActionRequiredControl_Async = require("Dashboards/Scripts/ActionRequiredControl");

import * as React from "react";
import * as ReactDOM from "react-dom";

export function delayLoadActionRequiredControl(element: JQuery, options: Dashboard_Shared_Contracts.IActionRequiredControlOptions): void {
    VSS.requireModules(["Dashboards/Scripts/ActionRequiredControl"]).spread(
        (TFS_Dashboards_ActionRequiredControl: typeof TFS_Dashboards_ActionRequiredControl_Async) => {
            Controls.BaseControl.createIn(TFS_Dashboards_ActionRequiredControl.WidgetNotification, element, options);
        });
}


export function showWidgetAccessNotAvailableDialog(): void {
    VSS.requireModules(["Dashboards/Scripts/ActionRequiredControl"]).spread(
        (TFS_Dashboards_ActionRequiredControl: typeof TFS_Dashboards_ActionRequiredControl_Async) => {
            TFS_Dashboards_ActionRequiredControl.WidgetNotification.showDialog({
                title: TFS_Dashboards_Resources.WidgetNotificationConfigureDialogTitle,
                contentText: TFS_Dashboards_Resources.WidgetNotificationConfigureDialogMessage,
                cssClass: 'configure',
                isRichText: false
            });
        });
}

export enum WidgetHostDisplayMode {
    /** host being used for regular widget rendering */
    widget,
    /** host being used for widget preview during configuration */
    configurationPreview,
    /** host being used for widget lightbox */
    lightbox
}

// This is a special inteface that we used to support all the interface we want to support for the widget
export interface IWidgetInternal extends
    TFS_Dashboards_WidgetContracts.IConfigurableWidget,
    Dashboard_Shared_Contracts.IWidgetCustomMenu,
    Dashboard_Shared_Contracts.IWidgetSettings {

    dispose?: () => void;
    isDisposed?: () => boolean;
}

export interface IWidgetHost_FactoryContract extends Dashboard_Shared_Contracts.IWidgetHost_ChildContracts {
    /**
     * Gets the element associated with this control, to paint inside it.
     */
    getElement(): JQuery;
}

export interface IWidgetFactory {
    createWidgetContainer(widgetContribution: IExtensionContribution, widgetData: TFS_Dashboards_Contracts.WidgetResponse, widgetHost: Dashboard_Shared_Contracts.IWidgetHost_ChildContracts, teamContext: TeamContext): IPromise<IWidgetInternal>;
}

/** narrow subset of properties from Widget data object actually required for rendering via WidgetFactory */
export interface WidgetFactoryOptions {
    contributionId: string;
    /** @deprecated */
    typeId: string;
    /** @deprecated */
    loadingImageUrl?: string;
}

/** A blob responsible for rendering widgets, error and loading controls. */
export class WidgetFactory implements IWidgetFactory {

    private static setupWidgetOptions(
        isFirstPartyWidget: boolean,
        widgetData: WidgetFactoryOptions,
        widgetHost: Dashboard_Shared_Contracts.IWidgetHost_ChildContracts,
        teamContext: TeamContext
    ): Dashboard_Shared_Contracts.WidgetOptions {
        var widgetOptions: Dashboard_Shared_Contracts.WidgetOptions = <Dashboard_Shared_Contracts.WidgetOptions>{};
        widgetOptions.widgetService = new WidgetHostService(widgetHost).getService();

        if (isFirstPartyWidget) {
            widgetOptions.typeId = widgetData.typeId;
            widgetOptions.loadingImageUrl = widgetData.loadingImageUrl;
            widgetOptions.performanceScenario = widgetHost.getPerformanceScenario();
            widgetOptions.teamContext = teamContext
        }

        return widgetOptions;
    }
    public static renderWidgetContributionImpl(
        isFirstPartyWidget: boolean,
        widgetData: WidgetFactoryOptions,
        widgetHost: Dashboard_Shared_Contracts.IWidgetHost_ChildContracts,
        teamContext: TeamContext
    ): IPromise<IWidgetInternal> {
        const instanceId: string = isFirstPartyWidget ? null : widgetData.typeId;

        // WidgetOptions is a init payload container, which allows us to avoid unintentional param collisions.
        var widgetOptions: Dashboard_Shared_Contracts.WidgetOptions = WidgetFactory.setupWidgetOptions(isFirstPartyWidget, widgetData, widgetHost, teamContext);

        // NOTE: when proxied widgets that are to be typed do not return, a console error for message having no receiver is sent.
        // we need to a way from the framework team to capture this information and show an error experience.
        return Contributions_Controls.createContributedControl<IWidgetInternal>(
            widgetHost.getWidgetContainer(),
            widgetData.contributionId,
            widgetOptions,
            null,
            instanceId,
            {
                showLoadingIndicator: false,
                showErrorIndicator: false,
                slowWarningDurationMs: 0,
                teamContextOverride: teamContext
            });
    }

    public createWidgetContainer(
        widgetContribution: IExtensionContribution,
        widgetData: TFS_Dashboards_Contracts.WidgetResponse,
        widgetHost: Dashboard_Shared_Contracts.IWidgetHost_ChildContracts,
        teamContext: TeamContext): IPromise<IWidgetInternal> {

        // instanceId for contributed controls.
        const isFirstParty = Contribution_Services.ExtensionHelper.hasInternalContent(widgetContribution);
        return WidgetFactory.renderWidgetContributionImpl(isFirstParty, widgetData, widgetHost, teamContext);
    }
}

/**
 * Host service that accepts interactions from the widget
 */
export class WidgetHostService {

    private widgetHost: Dashboard_Shared_Contracts.IWidgetHost_ChildContracts;

    constructor(widgetHost: Dashboard_Shared_Contracts.IWidgetHost_ChildContracts) {
        this.widgetHost = widgetHost;
    }

    /**
    *  service method called by a widget to request for the configuration view to be opened by the Host.
    */
    private showConfiguration(): void {
        if (UserPermissionsHelper.CanEditDashboard()) {
            this.widgetHost.configure();
        }
        else {
            showWidgetAccessNotAvailableDialog();
        }
    }

    /**
     * Return the minimal service interface that we want to expose.
     */
    public getService(): IPromise<Dashboards_Services.IWidgetHostService> {
        return Q({
            showConfiguration: () => this.showConfiguration(),
            getWidgetId: () => {
                var widget = this.widgetHost.getWidget();
                return Q.resolve((widget != null) ? widget.id : null);
            }
        });
    }
}
